import { render, staticRenderFns } from "./addMajor.vue?vue&type=template&id=22ce014e&scoped=true&"
import script from "./addMajor.vue?vue&type=script&lang=js&"
export * from "./addMajor.vue?vue&type=script&lang=js&"
import style0 from "./addMajor.vue?vue&type=style&index=0&id=22ce014e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce014e",
  null
  
)

export default component.exports